<div class='cover'
	id="{{dropDownId}}"
	*ngIf='isDropDownOpen'
	(click)="toggle(toggleBtn)"
	(keydown.enter)="toggle(toggleBtn)"></div>
<section 
	[ngClass]="{'vtr-ui-dropdown-disabled' : disabled}"
	class="vtr-ui-dropdown" 
	[class.opened]="isDropDownOpen"
	>
	<div class="input input-placeholder" [matTooltip]="text" matTooltipClass="vtr-system-tooltip">
		<div class="time">
			<span [title]="">{{ text }} </span>
		</div>
		<p class="chevron">
			<fa-icon *ngIf="!isDropDownOpen"
				[icon]="['fal', 'chevron-down']">
			</fa-icon>
			<fa-icon *ngIf="isDropDownOpen"
				[icon]="['fal', 'chevron-up']">
			</fa-icon>
		</p>
	</div>
	<div #toggleBtn
		class="input"
		[attr.aria-label]="label+' '+text"
		role="combobox"
		[attr.aria-expanded]="isDropDownOpen"
		[class.opened]="isDropDownOpen"
		(click)="toggle(toggleBtn)"
		(focus)="onDropdownFocus(toggleBtn)"
		(keydown.enter)="toggle(toggleBtn)"
		tabindex="0"
		id="{{dropDownId}}"
		[matTooltip]="text" matTooltipClass="vtr-system-tooltip">
		<div class="time">
			<span [title]="">{{ text }} </span>
		</div>
		<p class="chevron">
			<fa-icon *ngIf="!isDropDownOpen"
				[icon]="['fal', 'chevron-down']">
			</fa-icon>
			<fa-icon *ngIf="isDropDownOpen"
				[icon]="['fal', 'chevron-up']">
			</fa-icon>
		</p>
	</div>
	<div class="list"
		*ngIf="isDropDownOpen && !disabled"
		role="listbox">
		<ul>
			<li *ngFor="let item of list; last as isLast;index as i"
				id="{{dropDownId}}-item-{{i}}"
				tabindex="0"
				(click)="[select(item),toggleByItem(isLast,toggleBtn)]"
				(blur)="onItemBlur(isLast)"
				(keydown.enter)="[select(item),toggleByItem(isLast,toggleBtn)]"
				role="option"
				[ngClass]="{ 'selected-list-item': selectedValue === item.text }"
				attr.aria-label="{{ item.text }} selected,">
				<span [title]=""
					[matTooltip]="item.text"
					matTooltipClass="vtr-system-tooltip">{{ item.text }}</span>
			</li>
		</ul>
	</div>
</section>
